export var isTrue = function (value) {
    var _a, _b, _c;
    var val = (_b = (_a = value === null || value === void 0 ? void 0 : value.toUpperCase()) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '';
    return (_c = ['ON', 'YES', 'TRUE', '1'].includes(val)) !== null && _c !== void 0 ? _c : false;
};
